export default __webpack_public_path__ + "static/media/screen3.0d7c0810.png";